import { useV2MigrationStatus as useSharedV2MigrationStatus } from '@capsicum/features/nc-wallet/shared';
import { useNCWBalance } from '@capsicum/socios-core';

export const useV2MigrationStatus = () => {
	const { isPending: isNCWBalanceLoading, ncwBalance } = useNCWBalance();

	const { isLoading: isV2MigrationStatusLoading, isMigrating } = useSharedV2MigrationStatus({
		ongoingMigrations: ncwBalance?.ongoingMigrations ?? 0
	});

	return {
		isLoading: isNCWBalanceLoading || isV2MigrationStatusLoading,
		isMigrating
	};
};
